module.exports = __webpack_public_path__ + "img/sxmsq.9588e538.png";